import { graphql } from "../generated";

export const UserFragment = graphql(`
  fragment UserFragment on User {
    id
    trackingId
    name
    email
    views
    providers
    providersData {
      provider
      email
      createdAt
      updatedAt
    }
    isPremium
    premium {
      productId
      platform
    }
  }
`);
